import React from 'react';
// import Styles from './DashCoverLetter.module.scss'


const DashCoverLetter: React.FC = () => {
    return (
        <div>

        </div>
    );
};

export default DashCoverLetter;
